var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_593_1100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0027 32.5625L45.2816 25.6338C43.6096 24.7937 41.3642 24.7937 39.6963 25.6352L25.9766 32.5625L32.8749 36.0453V45.4668C33.3204 45.5287 33.7811 45.5892 34.2499 45.6497V36.7397L39.6977 39.4911C40.5323 39.9132 41.5113 40.1236 42.4889 40.1236C43.4666 40.1236 44.4469 39.9118 45.2829 39.4897L50.7513 36.7301V45.6511C51.2202 45.5906 51.6808 45.5301 52.1263 45.4682V36.0357L57.6263 33.2596V44.6102C57.6511 44.6061 57.6923 44.5978 57.6951 44.5978L59.0013 44.36V32.5638H59.0041L59.0027 32.5625ZM44.6614 38.2605C43.3827 38.9067 41.5966 38.9081 40.3164 38.2605L29.0277 32.5625L40.3164 26.8631C41.6158 26.2072 43.3621 26.2072 44.6628 26.8631L55.9529 32.5638L44.6628 38.2632L44.6614 38.2605ZM42.4986 49.0611C36.6067 49.0611 26.9061 47.3176 26.8084 47.2997L25.9986 47.154V57.8432L26.8084 57.6975C26.9061 57.6796 36.6067 55.9361 42.4986 55.9361C48.3904 55.9361 58.0911 57.6796 58.1887 57.6975L58.9986 57.8432V47.154L58.1887 47.2997C58.0911 47.3176 48.3904 49.0611 42.4986 49.0611ZM27.3736 48.7957C29.7496 49.2013 36.7634 50.3288 41.8111 50.4265V54.5707C36.7634 54.6697 29.7496 55.7958 27.3736 56.2015V48.7957ZM57.6236 56.2028C55.2476 55.7972 48.2337 54.6697 43.1861 54.5721V50.4278C48.2337 50.3288 55.2476 49.2027 57.6236 48.7971V56.2028Z",
    fill: "#00715D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_593_1100",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_593_1100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_593_1100",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/Academic.0d05002d2f29e52dd7c07d3c05060072.svg";
export { ForwardRef as ReactComponent };